import { render, staticRenderFns } from "./leadList.vue?vue&type=template&id=38f5921e&scoped=true"
import script from "./leadList.vue?vue&type=script&lang=js"
export * from "./leadList.vue?vue&type=script&lang=js"
import style0 from "./leadList.vue?vue&type=style&index=0&id=38f5921e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5921e",
  null
  
)

export default component.exports